import React, { Fragment } from 'react'

import { IconS24WritingPad24 } from '@is24/cosma-ui-icons'
import { InsertionFlowScreensProps } from '../../../../../@types/props-types'
import { SCREEN_OTHER_FACILITIES, SCREENS } from '../../../../../services/domain/wizardScreens'
import { OtherFacilitiesScreenValidationResult } from '../../../../../@types/validation-types'
import ScreenContainer from '../../../../common/containers/screenContainer/ScreenContainer'
import { FieldProps, TooltipTypes } from '../../../../../@types/types'
import { ScreenLayout } from '../../../../common/containers/screenLayout/ScreenLayout'
import { ScreenTooltip } from '../../../../common/display/screenTooltip/ScreenTooltip'

const screen = SCREENS[SCREEN_OTHER_FACILITIES]
export type OtherFacilitiesWrapperProps = FieldProps<OtherFacilitiesScreenValidationResult>

export type OtherFacilitiesAdditionalProps = {
  headerKey?: string
  screenTooltipKey?: string
  properties: ((otherFacilitiesWrapperProps: OtherFacilitiesWrapperProps) => JSX.Element)[]
}

const OtherFacilities: React.FC<
  InsertionFlowScreensProps<OtherFacilitiesScreenValidationResult> & OtherFacilitiesAdditionalProps
> = ({
  flowInformation,
  insertionData,
  validationMessages,
  properties,
  onChange,
  doReset,
  onNavigate,
  headerKey = 'wizard.screen.otherFacilities.header',
  screenTooltipKey,
}) => {
  const displayAppropriateTooltip = (tooltipType: TooltipTypes) => (
    <>{screenTooltipKey && <ScreenTooltip tooltipType={tooltipType} tooltipKey={screenTooltipKey} />}</>
  )

  const wrapperProps: OtherFacilitiesWrapperProps = {
    flowInformation: flowInformation,
    validationMessages: validationMessages,
    insertionData: insertionData,
    screenName: screen.name,
    screenId: screen.id,
    doReset: doReset,
    onChange: onChange,
  }
  return (
    <ScreenContainer containerId={screen.id} onNavigate={onNavigate} screen={screen}>
      <ScreenLayout
        id={`${screen.id}-desk-tooltip`}
        headline={headerKey}
        deskTooltip={displayAppropriateTooltip(TooltipTypes.DESKTOP)}
        mobileTooltip={displayAppropriateTooltip(TooltipTypes.MOBILE)}
        className='grid grid-flex gutter-vertical-l'
        headerIcon={<IconS24WritingPad24 />}
        screenName={screen.name}
      >
        {properties.map((item, index) => (
          <Fragment key={index}>{item(wrapperProps)}</Fragment>
        ))}
      </ScreenLayout>
    </ScreenContainer>
  )
}

export default OtherFacilities
